// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1qc2S","question":"styles_question__1V5QN","description":"styles_description__2kngc"};